<template>
    <div
        class="l-ss-c-filters-full-container"
        :class="{ 'l-ss-c-filters-full-container-without-header': !showHeader }"
        v-loading="loadingByFilters">
        <div class="l-ss-c-filters-full-header-wrapper">
            <div
                class="l-ss-c-filters-full-header"
                v-if="showHeader">
                <button
                    class="l-ss-c-button l-ss-c-button-plain l-ss-c-filters-full-btn"
                    @click="onClose">
                    {{ $t('filters.backToSearch') }}
                </button>
                <span class="l-ss-c-filters-full-title">{{ $t('filters.title') }}</span>
                <button
                    class="l-ss-c-button l-ss-c-button-plain l-ss-c-filters-full-btn"
                    @click="onReset">
                    {{ $t('filters.clearAll') }}
                </button>
            </div>
        </div>
        <div
            class="l-ss-c-filters-full-content">
            <filter-tags
                :active-filters="values"
                :filters="filters"
                :all-categories-tree="allCategoriesTree"
                :symbol="getSymbol('price')"
                :show-reset-btn="false"
                @change="emitFiltersChange"
                @reset-filters="onReset"/>

            <filter-container
                v-for="filter in checkFilters"
                :key="filter.name"
                :class="{ [`l-ss-c-filters-filter-${filter.type}`]: true }"
                :filter="filter"
                :has-results="hasResults"
                :with-inner-title="filter.type === 'checkbox'"
                collapse-mode
                :value="resolveValue(filter)"
                :all-categories-list="allCategoriesList"
                :symbol="getSymbol(filter.id)"
                @change="emitFiltersChange"
                @filter-click="params => $emit('filter-click', params)"/>

            <empty-results-header
                v-if="!checkFilters.length && !loadingByFilters"
                @reset-filters="onReset"/>
        </div>
        <div
            class="l-ss-c-filters-full-footer"
            v-if="hasChanges && totalItemsCount">
            <button
                class="l-ss-c-button"
                :disabled="!totalItemsCount"
                @click="showOffers">
                {{ showOffersText }}
            </button>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './FilterMixin';
    import FilterTags from '@/core/components/common/filters/filter-types/filter-tags/filter-tags.vue';
    import EmptyResultsHeader from '@/core/components/section-results/empty-results-header';
    import LoadingDirective from '@/core/directives/loading';
    import getDeclension from '@/core/helpers/get-declension';

    export default {
        components: { FilterTags, EmptyResultsHeader },
        directives: {
            loading: LoadingDirective,
        },
        mixins: [
            FilterMixin,
        ],
        inject: ['scrollToTop'],
        props: {
            showHeader: {
                type: Boolean,
                default: true,
            },
            currency: {
                type: String,
            },
            loadingByFilters: {
                type: Boolean,
                default: false,
            },
            allCategoriesList: {
                type: Array,
            },
            allCategoriesTree: {
                type: Array,
            },
        },
        data() {
            return {
                initialFilters: [],
            };
        },
        computed: {
            checkFilters() {
                const filters = [];

                this.filters.forEach((filter) => {
                    if (!this.$configuration.hiddenFilters.includes(filter.name)) {
                        if (this.$configuration.categoriesAsTree && filter.name === 'category') {
                            filters.push({
                                ...filter,
                                type: 'tree-enum',
                            });
                        } else {
                            filters.push(filter);
                        }
                    }
                });

                return filters;
            },
            toggleTypeFilters() {
                return this.checkFilters.filter(item => item.type === 'm-toggle');
            },
            showOffersText() {
                const foundItemsDeclensions = [
                    this.$t('results.showOffers.declension.first', [this.totalItemsCount]),
                    this.$t('results.showOffers.declension.second', [this.totalItemsCount]),
                    this.$t('results.showOffers.declension.third', [this.totalItemsCount]),
                ];

                return getDeclension(this.totalItemsCount, foundItemsDeclensions);
            },
            hasChanges() {
                if (this.initialFilters.length !== this.values.length) {
                    return true;
                }

                for (const filter of this.values) {
                    const { field } = filter;

                    const initialFilter = this.initialFilters.find(item => item.field === field);

                    if (!initialFilter) {
                        return true;
                    }

                    if (initialFilter.options) {
                        if (initialFilter.options.length !== filter.options.length ||
                            initialFilter.options.some(option => !filter.options.includes(option))
                        ) {
                            return true;
                        }
                    }

                    if (initialFilter.condition === 'range' &&
                        (initialFilter.min !== filter.min || initialFilter.max !== filter.max)
                    ) {
                        return true;
                    }

                    if (initialFilter.condition === 'equal' && initialFilter.value !== filter.value) {
                        return true;
                    }
                }

                return false;
            },
        },
        mounted() {
            this.initialFilters = JSON.parse(JSON.stringify(this.values));
        },
        methods: {
            showOffers() {
                this.onClose();
                this.scrollToTop();

                this.$emit('click-on-show-offers', this.showOffersText);
            },
            onClose() {
                if (!this.totalItemsCount) {
                    this.onReset();
                }
                this.$emit('close');
            },
            onReset() {
                this.$emit('reset');
            },
            emitFiltersChange(data) {
                this.$emit('filters-change', data);
            },
        },
    };
</script>
